import { render, staticRenderFns } from "./TagsController.vue?vue&type=template&id=230e5ecc&scoped=true&"
import script from "./TagsController.vue?vue&type=script&lang=ts&"
export * from "./TagsController.vue?vue&type=script&lang=ts&"
import style0 from "./TagsController.vue?vue&type=style&index=0&id=230e5ecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e5ecc",
  null
  
)

export default component.exports